export const CUSTOMER_ADMIN_ROLE = "Customer Admin";
export const CUSTOMER_CROP_ADVISOR_ROLE = "Customer Crop Advisor";
